<div class="m-2 lg:m-6" *ngIf="charges$ | async as charges; else loading">
  <div class="font-semibold text-2xl mb-2">Insured Trucks</div>
  <div class="grid grid-cols-3 ml-3 mr-4">
    <div class="font-bold mb-2">VIN</div>
    <div class="font-bold mb-2">Driver Name</div>
    <div class="font-bold mb-2">Insured Value</div>
    <ng-container *ngIf="charges.insuredTrucks?.length; else noInsuredTrucks">
      <ng-container *ngFor="let truck of charges.insuredTrucks; trackBy: 'id' | trackByKey">
        <div>{{ truck.vin }}</div>
        <div>{{ truck.driverName }}</div>
        <div>{{ truck.valueInPennies | currencyInPennies }}</div>
      </ng-container>
    </ng-container>
    <ng-template #noInsuredTrucks>
      <div class="col-span-3 flex justify-center">You do not have any insured trucks</div>
    </ng-template>
  </div>

  <div class="font-semibold text-2xl mt-4 mb-2">Driver Charges</div>
  <div class="grid grid-cols-3 ml-3 mr-4">
    <div class="font-bold mb-2">Driver Name</div>
    <div class="font-bold mb-2">Every Day Total</div>
    <div class="font-bold mb-2">Work Day Total</div>
  </div>
  <ng-container *ngIf="(driverCharges$ | async)?.length; else noDriverItems">
    <mat-accordion *ngFor="let driver of driverCharges$ | async; trackBy: 'driverName' | trackByKey">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="w-full flex items-center"
          ><div class="grid grid-cols-3 w-full">
            <div>{{ driver.driverName }}</div>
            <div>{{ driver.everyDayTotal | currencyInPennies }}</div>
            <div>{{ driver.workDayTotal | currencyInPennies }}</div>
          </div>
        </mat-expansion-panel-header>
        <div class="font-semibold text-xl mb-2">Every Day Charges</div>
        <div *ngFor="let item of driver.everyDayCharges; trackBy: 'displayName' | trackByKey" class="flex">
          <div class="w-1/3 font-bold">
            {{ item.displayName }}
          </div>
          <div class="w-1/3 font-bold">
            {{ item.costInPennies | currencyInPennies }}
          </div>
        </div>
        <div class="font-semibold text-xl mt-4 mb-2">Work Day Charges</div>
        <div *ngFor="let item of driver.workDayCharges; trackBy: 'displayName' | trackByKey" class="flex">
          <div class="w-1/3 font-bold">
            {{ item.displayName }}
          </div>
          <div class="w-1/3 font-bold">
            {{ item.costInPennies | currencyInPennies }}
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
  <ng-template #noDriverItems>
    <div class="col-span-3 flex justify-center">You do not have any daily billing items</div>
  </ng-template>
</div>

<ng-template #loading>
  <div class="flex justify-center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
